<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>任务确认</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card shadow="hover">
      <span>当前用户:{{userName}}</span>
      <span style="margin-left: 20px">任务类型:<el-select v-model="taskType" clearable>
        <el-option
          v-for="item in TaskType"
          :label="item"
          :value="item"
        ></el-option>
      </el-select></span>
      <span style="margin-left: 20px">请选择规划周期:
      <el-select placeholder="请选择规划周期" clearable v-model="planTitle" :disabled="this.taskType === '维修任务'">
        <el-option
          v-for="item in planTitleList"
          :label="item.planTitle"
          :value="item.planningId"
        >
        </el-option>
      </el-select></span>
      <span style="margin-left: 20px"><el-button type="primary" @click=" getInspectTask(2)">查询</el-button></span>
      <span style="margin-left: 20px"><el-button type="info" @click="reset">重置</el-button></span>
      <div style="margin-top:20px"><el-button type="primary" @click="batchConfirmInspectTask" :disabled="inspectDisabled">确认</el-button></div>
      <el-table v-show="inspectShow" ref="multipleTable" :data="inspectTaskList" :default-sort="{prop:'confirm', order:'descending'}">
        <el-table-column type="selection" show-overflow-tooltip :selectable='selectEnable'></el-table-column>
        <el-table-column prop="pointName" label="设备名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop="areaName" label="区域" show-overflow-tooltip></el-table-column>
        <el-table-column prop="alarmPointType" label="设备类型" show-overflow-tooltip></el-table-column>
        <el-table-column prop="confirm" label="是否确认" show-overflow-tooltip sortable></el-table-column>
<!--        <el-table-column prop="operation" label="操作" show-overflow-tooltip>-->
<!--          <template slot-scope="scope">-->
<!--            <el-button type="primary" size="mini" :disabled="scope.row.confirm==='已确认'" @click="confirmInspectTask(scope.row)">确认</el-button>-->
<!--            <el-button type="info" size="mini" :disabled="scope.row.confirm==='已确认'" @click="cancelInspectTask(scope.row)">取消</el-button>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column v-if="false" prop="alarmPointId" label="设备ID" show-overflow-tooltip></el-table-column>
        <el-table-column v-if="false" prop="planningId" label="设备ID" show-overflow-tooltip></el-table-column>
      </el-table>


      <el-table v-show="repairShow" ref="multipleTable1" :data="repairTaskList" :default-sort="{prop:'confirm', order:'descending'}">
        <el-table-column type="selection" show-overflow-tooltip :selectable='selectEnable'></el-table-column>
        <el-table-column prop="reportTitle" label="报修标题" show-overflow-tooltip></el-table-column>
        <el-table-column prop="pointName" label="设备名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop="reporterName" label="报修人" show-overflow-tooltip></el-table-column>
        <el-table-column prop="assignorName" label="被分配人" show-overflow-tooltip></el-table-column>
        <el-table-column prop="confirm" label="是否确认" show-overflow-tooltip sortable></el-table-column>
<!--        <el-table-column prop="operation" label="操作" show-overflow-tooltip>-->
<!--          <template slot-scope="scope">-->
<!--            <el-button type="primary" size="mini" :disabled="scope.row.confirm==='已确认'" @click="confirmRepairTask(scope.row)">确认</el-button>-->
<!--            <el-button type="info" size="mini" :disabled="scope.row.confirm==='已确认'" @click="cancelRepairTask(scope.row)">取消</el-button>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column v-if="false" prop="_id" label="设备ID" show-overflow-tooltip></el-table-column>
        <el-table-column v-if="false" prop="planningId" label="巡检周期ID" show-overflow-tooltip></el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
  import store from '../../../store.js'
    export default {
        name: "taskConfirm",
      data(){
          return{
            inspectShow:true,//巡检任务确认的表格是否显示
            repairShow:false,//维修任务确认的表格是否显示
            taskType:'巡检任务',//任务类型
            TaskType:['巡检任务','维修任务'],
            userName:'',
            userId:'',
            planTitle:'',
            inspectDisabled:true,//批量处理是否可用
            getPlanTitleList:{//获取规划周期
              "version":1.0,
              "method":'distribution.GetPlanningTitle',
              "params":{
            },
		        "token":"#",
            "id":0
            },
            planTitleList:[
              {
                "planningId":'',
                "planTitle":''
              }
            ],
            inspectTaskList:[],
            GetInspectTaskInfo:{//获取巡检表格数据
              "version":1,
              "method":"planning.GetPlanPoints",
              "params":{
                "pageNumber":1,
                "planningId":'',
                "assignorName":'',
              },
              "token":"#",
              "id":0
            },
            repairTaskList:[],
            GetReportTaskInfo:{//获取报修记录列表
              "version":1,
              "method":"report.GetReportRecordList",
              "params": {
                "pageNumber":1,
                "alarmPointId":'',
                "pointName":'',
                "reportTitle":'',
                "reporterName":'',
                "assignorName":'',
                "startTime":'',
                "endTime":'',
                "flag":false,
                "isConfirm":'',//是否分配
                "isResolved":''//是否解决
              },
              "token":"#",
              "id":0
            },
            confirmInspect:{
              "version":1,
              "method":"distribution.ConfirmInspectTaskes",
              "params":{
                "userId":'',
                "planningPointList":[],
                "planningId":''
              },
              "token":"#",
              "id":0
            },
            confirmRepair:{
              "version":1,
              "method":"distribution.ConfirmRepairTaskes",
              "params":{
                "userId":'',
                "reportIdList":[]
              },
              "token":"#",
              "id":0
            },
            cancelRepair:{
              "version":1,
              "method":"distribution.CancelRepairTaskes",
              "params":{
                "reportIdList":[],
              },
              "token":"#",
              "id":0
            },
            cancelInspect:{
              "version":1,
              "method":"distribution.CancelInsperctionTaskes",
              "params":{
                "planningId":'',
                "planningPointList":[]
              },
              "token":"#",
              "id":0
            }

          }
      },
      methods:{
          getUserList(){//获取当前用户
               this.userName = localStorage.getItem('name');
               //alert(localStorage.getItem('name'));
               //this.userId = store.state.userInfo.userId.toString();
          },
          getPlanTitle(){//获取规划主题
            for(let i in this. getPlanTitleList.params){
              if(this. getPlanTitleList.params[i] ===''){
                this. getPlanTitleList.params[i] = null;
              }
            }
            this.getPlanTitleList.token = this.$store.state.token;
            this.$axios.post(this.$mainUrl,this. getPlanTitleList).then(res=>{
              if(res.data.hasOwnProperty('result')){
                  this.planTitleList = res.data.result.planTitleList;
              }
            })
          },
        getInspectTask(val){
          if(this.taskType === '巡检任务'){
            this.inspectShow = true;
            this.repairShow = false;
            this.inspectTaskList = [];
              for (let val in this.GetInspectTaskInfo.params) {
                if (this.GetInspectTaskInfo.params[val] === "") {
                  this.GetInspectTaskInfo.params[val] = null;
                }
              }
            if(val == 2){
              this.GetInspectTaskInfo.params.pageNumber = 1;
            }
              this.GetInspectTaskInfo.token = this.$store.state.token;
              this.GetInspectTaskInfo.params.planningId = this.planTitle;
              this.GetInspectTaskInfo.params.assignorName = this.userName;
              this.$axios.post(this.$mainUrl, this.GetInspectTaskInfo).then(res => {
                if (res.data.hasOwnProperty('result')) {
                  for (let i = 0; i < res.data.result.planningPointList.length; i++) {
                    if (res.data.result.planningPointList[i].assignorName != "") {
                      if (res.data.result.planningPointList[i].confirm == true) {
                        res.data.result.planningPointList[i].confirm = '已确认'
                      } else {
                        res.data.result.planningPointList[i].confirm = '未确认'
                      }
                      this.inspectTaskList.push(res.data.result.planningPointList[i]);
                    }
                  }
                  ;
                  return this.inspectTaskList
                }
              })
          }
          if(this.taskType === '维修任务') {
            this.inspectShow = false;
            this.repairShow = true;
            this.repairTaskList = [];
            let array = [];
            this.GetReportTaskInfo.params.assignorName = this.userName;
            if(val == 2){
              this.GetReportTaskInfo.params.pageNumber = 1;
            }
            for (let val in this.GetReportTaskInfo.params){
              if(this.GetReportTaskInfo.params[val] === ""){
                this.GetReportTaskInfo.params[val] = null;
              }
            };
            this.$axios.post(this.$mainUrl,this.GetReportTaskInfo).then(res=>{
              if(res.data.hasOwnProperty('result')){
                for(let i=0;i<res.data.result.reportRecordList.length;i++){
                  if(res.data.result.reportRecordList[i].assignorName){
                    if (res.data.result.reportRecordList[i].confirm == true) {
                      res.data.result.reportRecordList[i].confirm = '已确认'
                    }else{
                      res.data.result.reportRecordList[i].confirm = '未确认'
                    }
                    array.push(res.data.result.reportRecordList[i]);
                  }
                };
                this.repairTaskList = array;
              }
            })
          }

        },
        batchConfirmInspectTask(){//批量处理巡检任务
            if(this.taskType === '巡检任务'){

              if(this.$refs.multipleTable.selection.length == 0){
                alert("请至少选择一条巡检任务！")
              }else{
                this.confirmInspect.params.planningPointList = [];
                this.confirmInspect.params.planningId = this.$refs.multipleTable.selection[0].planningId;
                this.confirmInspect.params.userId = localStorage.getItem('userId');
                for(let i=0;i<this.$refs.multipleTable.selection.length;i++){
                  this.confirmInspect.params.planningPointList.push(this.$refs.multipleTable.selection[i].alarmPointId);
                };
                for (let val in this.confirmInspect.params){
                  if(this.confirmInspect.params[val] === ""){
                    this.confirmInspect.params[val] = null;
                  }
                };
                this.$confirm("是否确认接受巡检任务？",{
                  confirmButtonText:'确定',
                  cancelButtonText:'取消',
                  type:'warning'
                }).then(()=>{
                  this.$axios.post(this.$mainUrl,this.confirmInspect).then(res=>{
                    if(res.data.hasOwnProperty('result')){
                      this.inspectTaskList = [];
                      this.getInspectTask(1);
                    }
                  })
                }).catch(()=>{
                  this.$message({
                    type:'info',
                    message:'已取消'
                  })
                })
              }

            }
            if(this.taskType === '维修任务'){
              if(this.$refs.multipleTable1.selection.length == 0){
                alert("请至少选择一条维修任务！");
              }else{
                this.confirmRepair.params.reportIdList = [];
                this.confirmRepair.params.userId = localStorage.getItem('userId').toString();
                for(let i=0;i<this.$refs.multipleTable1.selection.length;i++){
                  //alert(this.$refs.multipleTable1.selection[i]._id)
                  this.confirmRepair.params.reportIdList.push(this.$refs.multipleTable1.selection[i]._id);
                }
                for (let val in this.confirmInspect.params){
                  if(this.confirmInspect.params[val] === ""){
                    this.confirmInspect.params[val] = null;
                  }
                };
                this.$confirm("是否确认接受维修任务？",{
                  confirmButtonText:'确定',
                  cancelButtonText:'取消',
                  type:'warning'
                }).then(()=>{
                  this.$axios.post(this.$mainUrl,this.confirmRepair).then(res=>{
                    if(res.data.hasOwnProperty('result')){
                      //alert(res.data.result.asOfTimePoint[0])
                      if(res.data.result.asOfTimePoint){
                        alert("有维修任务超出维修截止时间！无法确认")
                      }else{
                        this.repairTaskList = [];
                        this.getInspectTask(1);
                      }
                    }
                  })
                }).catch(()=>{
                  this.$message({
                    type:'info',
                    message:'已取消'
                  })
                })
              }
            }

        },
        reset(){
          this.taskType = []
          this.planTitle = ''
        },
        selectEnable(row,rowindex){
          if(this.$refs.multipleTable1.selection.length !=0||this.$refs.multipleTable.selection.length !=0) {
            this.inspectDisabled = false;
          }else{
            this.inspectDisabled = true;
          }
          if(row.confirm == '已确认'){
            return false;
          }else{
            return true
          }
        },
      },
      mounted () {
        this.getPlanTitle();
        this.getUserList();
        this.getInspectTask(1)
        this.search();
      },
    }
</script>

<style scoped>

</style>
